import createIcon from '../../createIcon';

/**
 * @component @name Bloodtype
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjY3IDYuNTUgNCAxMC40OCA0IDEzLjhDNCAxOC43OCA3LjggMjIgMTIgMjJDMTYuMiAyMiAyMCAxOC43OCAyMCAxMy44QzIwIDEwLjQ4IDE3LjMzIDYuNTUgMTIgMlpNMTUgMThIOVYxNkgxNVYxOFpNMTUgMTNIMTNWMTVIMTFWMTNIOVYxMUgxMVY5SDEzVjExSDE1VjEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Bloodtype = createIcon('Bloodtype', [
  [
    'path',
    {
      d: 'M12 2C6.67 6.55 4 10.48 4 13.8C4 18.78 7.8 22 12 22C16.2 22 20 18.78 20 13.8C20 10.48 17.33 6.55 12 2ZM15 18H9V16H15V18ZM15 13H13V15H11V13H9V11H11V9H13V11H15V13Z',
      key: 'hxfkph',
    },
  ],
]);

export default Bloodtype;
